<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md5>
        <v-card class="rounded-card elevation-6 pa-3">
          <v-toolbar dark color="primary lighten-2">
            <v-toolbar-title>Reset Password</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat color="white" @click="login" small outline
              >Login?</v-btn
            >
          </v-toolbar>
          <v-card-text>
            <span class="caption mb-4">Enter your new password</span>
            <v-alert
              v-if="error"
              :value="true"
              type="error"
              icon="warning"
              class="mb-4"
            >
              {{ errorMessage }}
            </v-alert>
            <v-form
              id="resetForm"
              ref="form"
              v-model="valid"
              lazy-validation
              class="my-2"
              @submit.prevent
            >
              <v-text-field
                v-model="password"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                prepend-icon="lock"
                name="password"
                label="Password"
                :type="showPassword ? 'text' : 'password'"
                :rules="passwordRules"
                hint="At least 7 characters"
                counter
                required
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="mt-2 grey lighten-5 rounded-card">
            <v-btn
              :disabled="!valid"
              type="submit"
              color="accent"
              round
              block
              :loading="loading"
              form="resetForm"
              @click="validate"
              >Submit</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-btn
          flat
          color="secondary"
          small
          text
          nuxt
          @click="login"
          class="text-lowercase font-weight-thin"
          >Remember your old password?</v-btn
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data: () => ({
    error: false,
    errorMessage: null,
    showPassword: false,
    loading: false,
    valid: true,
    password: null,
    forgotId: null,
    passwordRules: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 7) || 'Minimum 7 characters'
    ]
  }),
  methods: {
    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await this.reset({
            forgotId: this.$route.query.requestId,
            password: this.password
          });
          this.loading = false;
          if (response && response.success) {
            this.setSnack('You have successfully reset your password');
            this.$router.push(`/login?email=${response.email}`);
          } else {
            this.errorMessage = response
              ? response.message
              : 'Unable to process request at this time. Please try again later';
            this.error = true;
          }
        } catch (error) {
          this.loading = false;
          this.errorMessage = error.message;
          this.error = true;
        }
      }
    },
    login() {
      if (this.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        this.$router.push(`/login?email=${encodeURIComponent(this.email)}`);
      } else {
        this.$router.push('/login');
      }
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack',
      reset: 'account/resetPassword'
    })
  }
};
</script>
<style>
.rounded-card {
  border-radius: 10px;
}
</style>
